// extracted by mini-css-extract-plugin
export var error = "style-module--error--5c995";